module.exports = __webpack_public_path__ + "img/imgres.f120c655.png";